jQuery.noConflict();
jQuery(window).on('resize',function() {
    var $mobileMenu=jQuery('.mobile-menu');
    if (jQuery(window).width() < 992) {
        if ($mobileMenu.find('li.menu-item-has-children').find('.subMenuToggler').length == 0) {
            $mobileMenu.find('li.menu-item-has-children').each(function () {
                var $this = jQuery(this);
                //if($this.hasClass('menu-item-has-children')){
                $this.children('a').addClass('togglerParent');
                $this.children('a').append('<span class="subMenuToggler"></span>')
                //}
            });
            jQuery('.mobile-menu .sub-menu').each(function () {
                var $this = jQuery(this);
                var a = $this.prev('.togglerParent');
                if ($this.find('.first-subMenu').length === 0)
                    $this.prepend('<li class="first-subMenu"><span class="close-subMenu"><span class="icon-keyboard_arrow_left"></span></span><a class="menu-bar-heading-category" href="' + a.prop("href") + '">' + a.contents().not(a.children()).text() + '</a></li>');
            });
        }
    }
    jQuery(document).find('.main-menu-container').find('.menu-container').css('top', (jQuery('.header-bar').outerHeight()+jQuery('.main-menu-container').outerHeight() )+'px')
    jQuery(document).find('.top-bar').find('.cart-menu').css('top', (jQuery('.header-bar').outerHeight()+jQuery('.main-menu-container').outerHeight() )+'px')
    jQuery(document).find('.top-bar').find('.cart-menu').css('top', (jQuery('.header-bar').outerHeight()+jQuery('.main-menu-container').outerHeight() )+'px')
    jQuery(document).find('.sidebar-filters').css('top', (jQuery('.header-bar').outerHeight()+jQuery('.main-menu-container').outerHeight() )+'px')
});


jQuery(document).ready(function ($) {

    var forEach = function (array, callback, scope) {
        for (var i = 0; i < array.length; i++) {
            callback.call(scope, i, array[i]); // passes back stuff we need
        }
    };

    var $menu_overlay = $('.menu-overlay');
    var $shop_sidebar_wrapper = $('.sidebar-filters');

    $menu_overlay.on('click', function () {
        $menu_overlay.removeClass('show');
        $('.menu-container').removeClass('show');
        $(document).find('.cart-menu').removeClass('show')
        $('.cart-icon').removeClass('cart-opened');
        $('body').removeClass('menu-show')
    });

    function copy(value) {
        var tempInput = document.createElement("input");

        tempInput.style = "position: absolute; left: -1000px; top: -1000px";
        tempInput.value = value;
        document.body.appendChild(tempInput);
        tempInput.select();
        try {
            var successful = document.execCommand('copy', false, null);
            var msg = successful ? 'successful' : 'unsuccessful';
            console.log('Copying text command was ' + msg);
        } catch (err) {
            alert('Oops, unable to copy to clipboard');
        }
        document.body.removeChild(tempInput);
    }

    var $productSocial = $('#productSocial');

    $productSocial.find('.social-garment-link').on('click', function (e) {
        e.preventDefault();
        copy($(this).data('link'));
        $(this).text("Αντιγράφηκε στο πρόχειρο...");
    });

    $('.scroll-to-description').on('click', function (e) {
        e.preventDefault();
        $('html, body').animate({
            scrollTop: $("#description-section").offset().top
        }, 500);
    });

    jQuery('#productSocial a').click(function () {
        var left = (screen.width / 2) - (550 / 2);
        var top = (screen.height / 2) - (350 / 2);
        var NWin = window.open(jQuery(this).prop('href'), '', 'height=350,width=550,top=' + top + ', left=' + left);
        if (window.focus) {
            NWin.focus();
        }
        $productSocial.fadeOut();
        return false;
    });

    $('.share-modal-opener').on('click', function (e) {
        $productSocial.fadeIn();
    });

    $productSocial.find('.social-close').on('click', function (e) {
        e.preventDefault();
        $productSocial.fadeOut();
    });




        //fixed-header
        if (jQuery(window).width() < 992) {
            $(window).bind('scroll', function () {
                var height = $(".espa-row" ).outerHeight() +  $(".top-bar-container " ).outerHeight();
                if ($(window).scrollTop() > height) {
                    $('.mobile-container').addClass('fixed-header');
                    $("body").css("padding-top", $('.mobile-container').outerHeight());
                } else {
                    $('.mobile-container').removeClass('fixed-header');
                    $("body").css("padding-top", "0");
                }
            });
        }



    if ($(window).width() < 1200) {
        $(window).trigger('resize');
        $('.menu-overlay-2').on('click', function () {
            $('.main-menu-mobile').removeClass('show');
        });

        $('.mobile_btn').on("click", function (e) {
            $('.main-menu-mobile').toggleClass('show');
            if($('.main-menu-mobile').hasClass('show')){
                $menu_overlay.addClass('show');
                $('body').addClass('menu-show');
            }else {
                $menu_overlay.removeClass('show');
                $('body').removeClass('menu-show');
            }
        });


        $(document).on('click', '.subMenuToggler', function () {
            var $this = $(this);
            var parent = $this.parent('a').parent('li');
            parent.children('ul.sub-menu').addClass('show');
            return false;
        });
        $('.main-menu-mobile').find('.main_menu').find('li.menu-item-has-children').find('>a').on('click', function (e) {
            e.preventDefault()
            var $this = $(this);
            var parent = $this.parent('li');
            parent.children('ul.sub-menu').addClass('show');
            if (parent.parent('ul.sub-menu').length > 0) parent.parent('ul.sub-menu').addClass('overflow-init')
            $('div.main-menu-mobile').addClass('overflow-init');
            return false;
        });
        $(document).on('click', '.close-subMenu', function () {
            var $this = $(this);
            var parent = $this.parent('li').parent('ul.sub-menu');
            parent.removeClass('show');
            return false;
        });
        $('.overlay-mob').on('click', function () {
            $('.sidebar-shop').removeClass('show');
        });
        $('.close-filters').on('click', function () {
            $('.sidebar-shop').removeClass('show');
        });
        $('.product-filters').on('click', function (e) {
            $('.sidebar-shop').toggleClass('show');
        });
        $('.search-container').removeClass('show')

    }

    $(document).on('click', '.cart-menu .close-cart', function (e) {
        e.preventDefault();
        $(document).find('.cart-menu').removeClass('show')
        $('.cart-icon').removeClass('cart-opened')
        $menu_overlay.removeClass('show')
        $('body').removeClass('menu-show')
        $('.search-container').removeClass('show')
    })


    $('.size-picker').on('click',function(e){
        var $pa =$(this).data('pa');
        var $pick = '';
        $('.size-picker.checked.'+$pa).not(this).removeClass('checked');
        $(this).toggleClass('checked');
        if($(this).hasClass('checked')){$pick = $(this).data('pick');}
        $("select#"+$pa).val($pick).change();
        e.preventDefault();
    });
    $(document).on('show_variation', function () {
        var price_elem = $(document).find('.woocommerce-variation.single_variation').find('.woocommerce-variation-price');
        if(price_elem.length>0 && price_elem.html()!=''){
            $(document).find('form.cart').find('p.cart-price').html( price_elem.html())
        }/*else {
            console.log('bbb')
        }*/
    })

    //search form
    var $menu_wrapper=$(document).find('.main-menu-wrapper');
    var $menu_overlay=$('.menu-overlay');
    var $shop_sidebar_wrapper=$('.shop-sidebar-wrapper');
    if (jQuery(window).width() < 992) {
        $search_s = jQuery('#search-term');
    }else{
        $search_s=jQuery('#search-s');
    }

    $('#head-search-go').on('click',function(e) {
        e.preventDefault();
        var cat = $search_s.find('#search-category').val();
        var s = $search_s.val();
        if (cat>0) {
            window.location.replace(window.location.origin+'/?s='+s+'&post_type=product&product_cat='+cat);
        }else {
            window.location.replace(window.location.origin+'/?s='+s+'&post_type=product');
        }
    });

    $search_s.keyup(function(e){
        if(e.keyCode == 13)
        {
            $('#head-search-go').trigger('click');
        }
    });
    if($(document).find('#search-s, #search-term').length>0) {
        $search_s.on('click hover focus', function (e) {
            $('.sub-menu-categories').removeClass('show')
            $('.mobile-menu-wrapper').removeClass('show')
            $menu_wrapper.removeClass('show')
            $(document).find('.cart-menu').removeClass('show')
            $('.cart-icon').removeClass('cart-opened')
            // $('.categories-menu > li:first-child > a').removeClass('menu-opened')
            $('.categories-menu').children('li:first-child').children('a').removeClass('menu-opened');
            $menu_overlay.addClass('show')
            $('body').addClass('menu-show')
        })
        $('#search-category').on('click hover focus', function (e) {
            $('.sub-menu-categories').removeClass('show')
            $('.mobile-menu-wrapper').removeClass('show')
            $menu_wrapper.removeClass('show')
            $(document).find('.cart-menu').removeClass('show')
            $('.cart-icon').removeClass('cart-opened')
            $menu_overlay.addClass('show')
            $('body').addClass('menu-show')
            $search_s.autocomplete("search")
        })
        $search_s.on('focusout', function (e) {
            $menu_overlay.removeClass('show')
            $('body').removeClass('menu-show')
        })

        $search_s.autocomplete({
            minLength: 0,
            source: function(request, response) {
                $('.searchform-header').find('span').toggleClass('icon-search icon-spinner7 animate-spin')
                var data = {
                    'search': $search_s.val(),
                    'search-category': $('#search-category').val(),
                    'action': 'search_product'
                };
                $.ajax({
                    type: "POST",
                    url: ajax_object.ajax_url,
                    data: data,
                    dataType: "json",
                    success: function(data) {
                        response( $.map( data.data, function(item) {
                            return {
                                label: item.title ?? '',
                                image: item.image ?? '',
                                value: item.id ?? '',
                                url: item.link ?? '',
                                type: item.type ?? '',
                                price: item.price ?? '',
                                sku: item.sku ?? '',
                                category: item.category ?? '',
                                parent_name: item.parent_name ?? ''
                            }
                        }));
                        $('.searchform-header').find('span').toggleClass('icon-search icon-spinner7 animate-spin')
                    },
                });
            },select: function (event, ui) {
                if(ui.item.type != "title") $search_s.val(ui.item.label);
                return false;
            }
        }).autocomplete( "instance" )._renderItem = function( ul, item ) {
            if (item.type != 'title'){
                var search_val = $search_s.val().toLowerCase();
                var new_label = item.label;
                var lower_label = item.label.toLowerCase();
                if (lower_label.indexOf(search_val) > -1) {
                    var index = lower_label.indexOf(search_val);

                    new_label = item.label.substr(0, index);
                    new_label += "<strong>";
                    new_label += item.label.substr(index, search_val.length);
                    new_label += "</strong>";
                    new_label += item.label.substr((index + search_val.length), item.label.length);
                }
            }

            if(item.type == 'product') {
                var price_label = "<span class='price d-inline-block me-2'>" + item.price + "</span>";
                var categ_label = "<span class='category'>" + item.category + "</span>";
                var sku_label = "<span class='sku_label ms-2 d-none'>" + item.sku + "</span>";
                return $("<li>")
                    .append("<a href='" + item.url + "'><img src='" + item.image + "' width='50' height='50'> " + "<span class='title-search'>" + new_label + "</span>" +"<span class='d-block'>" + price_label + categ_label + sku_label + "</span>" + "</a>")
                    .appendTo(ul);
            }else if(item.type == 'title'){
                return $("<li class='search-green-label'>")
                    .append("<a href='" + item.url + "'>" + item.label + "</a>")
                    .appendTo(ul);
            }else {
                return $("<li class='search-term-label'>")
                    .append("<a href='" + item.url + "'>" + new_label + (item.count ? " <span class='count'>(" + item.count + ")</span>" : '') + "</a>")
                    .appendTo(ul);
            }
        };

        jQuery.ui.autocomplete.prototype._resizeMenu = function () {
            var ul = this.menu.element;
            ul.outerWidth(this.element.parent('form').outerWidth());
        }
    }

    $(document).on('click', '.cart-icon', function (e) {
        e.preventDefault();
        $('.cart-menu').toggleClass('show')
        $(this).toggleClass('cart-opened')

        $('.menu-container').removeClass('show');
        if ($(this).hasClass('cart-opened')) {
            $menu_overlay.addClass('show')
            $('body').addClass('menu-show')
        } else {
            $menu_overlay.removeClass('show');
            $('body').removeClass('menu-show')
        }
        if($shop_sidebar_wrapper.hasClass('show')) {
            $shop_sidebar_wrapper.removeClass('show');
            $('.filters-overlay').removeClass('show')
        }
        $('.search-container').removeClass('show')
    })

    $('#contact-form').on('submit', function (e) {
        e.preventDefault();
        $(this).validate();
        if ($(this).valid()) {
            data = $(this).serialize();
            jQuery.post(ajax_object.ajax_url, data, function (response) {
                $('.alert-container').html("<div class='alert alert-success'>Το μήνυμα σας στάλθηκε με επιτυχία</div>");
            });
        }
    });

    $( document.body ).on( 'wc_fragments_loaded', function(){
        if ($('body').hasClass('menu-show')) {
            $(document).find('.cart-icon').addClass('cart-opened')
            $(document).find('.cart-menu').addClass('show')
        }
    });


    if($(document).find('.woocommerce-cart').find('table.cart').find('td.product-quantity').find('.qty').length>0){
        $(document).find('.woocommerce-cart').find('table.cart').find('td.product-quantity').find('.quantity').each(function () {
            $(this).append('<button class="plus">+</button><button class="minus">-</button>')
        })
    }
    $(document).on( 'click', '.woocommerce-cart table.cart td.product-quantity button.plus, .woocommerce-cart table.cart td.product-quantity button.minus', function(e) {
        e.preventDefault()
        // Get current quantity values
        var qty = $( this ).parent( '.quantity' ).find( '.qty' );
        var val   = parseFloat(qty.val());
        var max = parseFloat(qty.attr( 'max' ));
        var min = parseFloat(qty.attr( 'min' ));
        var step = parseFloat(qty.attr( 'step' ));

        // Change the value if plus or minus
        if ( $( this ).is( '.plus' ) ) {
            if ( max && ( max <= val ) ) {
                qty.val( max );
                swal({icon: 'warning', text: 'Δεν είναι δυνατή η προσθήκη αυτής της ποσότητας στο καλάθι!',});
            } else {
                qty.val( val + step ).trigger('change');
            }
        } else {
            if ( min && ( min >= val ) ) {
                qty.val( min );
            } else if ( val > 1 ) {
                qty.val( val - step ).trigger('change');
            }
        }

    });
    $( document.body ).on( 'updated_cart_totals', function(){
        $(document).find('.woocommerce-cart').find('table.cart').find('td.product-quantity').find('.quantity').each(function () {
            $(this).append('<button class="plus">+</button><button class="minus">-</button>')
        })
    });
    $(document).on('change', '.woocommerce-cart table.cart td.product-quantity .qty', function () {
        $("[name='update_cart']").prop("disabled", false).trigger("click");
    })
    if (jQuery(window).width() >= 992) {
        $('.main_menu').hover(
            function () {
                $('.menu-overlay').addClass('show')
                $(document).find('.cart-menu').removeClass('show')
                $('.cart-icon').removeClass('cart-opened')
            },
            function () {
                $('.menu-overlay').removeClass('show')
            }
        )
    }
    if($('.woocommerce').find('.woocommerce-ordering').children('select.orderby').length>0 && $(window).width() >= 992){
        $('.woocommerce').find('.woocommerce-ordering').children('select.orderby').selectWoo({minimumResultsForSearch: Infinity})
    }

    $(document).on('click', '.woocommerce-cart table.cart td.actions .empty_cart', function () {
        var $this = $(this)
        $this.prop('disabled', true).find('span').remove()
        $this.append('<span class="icon-spinner7 animate-spin"></span>');
        new swal({
            title: "Διαγραφή Καλαθιού",
            text: "Είστε σίγουροι ότι θέλετε να αδειάσετε το καλάθι σας;",
            icon: "warning",
            buttons: [
                'Ακύρωση',
                'Διαγραφή όλων'
            ],
            dangerMode: true,
        }).then(function(isConfirm) {
            if (isConfirm) {
                var data = {
                    'action': 'remove_all_cart'
                };
                jQuery.post(ajax_object.ajax_url, data, function (response) {
                    $("[name='update_cart']").prop("disabled", false).trigger("click");
                    $this.prop('disabled', false).find('span').toggleClass('icon-spinner7 animate-spin icon-ok')
                });
            }else {$this.prop('disabled', false).find('span ').remove()}
        })
    })
    $(document).on('click', '.woocommerce-cart table.cart td.product-extras label', function () {
        var $this = $(this);
        var val = 'yes';
        var $for = $this.attr('for');
        if($('#'+$for).is(':checked')){
            val = 'no';
        }
        var $field = $this.data('field');
        var data = {'action':'prefix_update_cart_checkboxes', cart_id: $this.data('cart-id'), security: $('#woocommerce-cart-nonce').val(), val: val, field:$field};
        $.ajax({url:ajax_object.ajax_url,data:data,method: 'post', success:function(result){
            var $tigger = true;
            if ($field == 'include_card'){
                if(val == 'no'){
                    $this.parent('.product-extras').find('.cart-content').slideUp()
                }else{
                    $this.parent('.product-extras').find('.cart-content').slideDown()
                    $tigger = false;
                }
            }
            if($tigger == true)
                $("[name='update_cart']").prop("disabled", false).trigger("click");
        }});
    })
    $('#we-bacs-completed').on('submit', function (e) {
        e.preventDefault()
        var $btn = $(this).find('.btn-primary');
        $btn.prop('disabled', true).find('i').remove();
        $btn.append('<i class="icon-spinner animate-spin ml-2"></i>')
        $(this).validate();
        if ($(this).valid()) {
            var formData = new FormData($(this)[0]);
            $.ajax({
                url: ajax_object.ajax_url,
                type: 'POST',
                contentType: false,
                dataType: "json",
                data: formData,
                cache: false,
                processData: false,
                success: function (data) {
                    swal({icon: 'success', text: 'Το μήνυμα σας εστάλη με επιτυχία! Ευχαριστούμε πολύ.',});
                    $btn.prop('disabled', false).find('i').toggleClass('icon-spinner animate-spin icon-check')
                }
            })
        }else{$btn.prop('disabled', false).find('i').remove();}
    })


    $(document).on('change', '.toggle-return-hidden-content', function () {
        $('.return-hidden-content').slideUp()
        if($(this).is(':checked'))
            $(this).parent('label').next('.return-hidden-content').fadeIn()
        else $(this).parent('label').next('.return-hidden-content').fadeOut()
    })
    $(document).on('change', '.open-input', function () {
        if($(this).is(':checked'))
            $(this).parent('label').next('.return-product-code').fadeIn()
        else $(this).parent('label').next('.return-product-code').fadeOut()
    })
    $(document).on('click', '.return-products-list h4', function () {
        $(this).toggleClass('toggled').next('.row').slideToggle().css('display', 'flex')
    })

    $('#interest-form').on('submit', function (e) {
        e.preventDefault();
        var $btn = $(this).find('.btn-primary');
        $btn.prop('disabled', true).find('i').remove();
        $btn.append('<i class="icon-spinner animate-spin ml-2"></i>');
        $(this).validate();
        if ($(this).valid()) {
            data = $(this).serialize();
            $.ajax({
                url: ajax_object.ajax_url,
                data: data,
                method: 'post',
                success: function (result) {
                    $('#modalInterest').modal('hide')
                    swal({
                        icon: 'success',
                        title: 'Σας ευχαριστούμε για το ενδιαφέρον!',
                        text: 'Θα σας ειδοποιήσουμε όταν το προϊόν είναι διαθέσιμο.',
                    });
                    $btn.prop('disabled', false).find('i').toggleClass('icon-spinner animate-spin icon-check')
                }
            });
        }else $btn.prop('disabled', false).find('i').remove();
    });

    if($('.related').find('ul.products').find('li.product').length > 0){
        var sliders = document.querySelectorAll('.related ul.products');

        forEach(sliders, function (index, value) {
            var slider = tns({
                container: value,
                loop:false,
                mouseDrag:true,
                navPosition:'bottom',
                gutter:4,
                items:1.3,
                nav:true,
                preventScrollOnTouch:false,
                controls:false,
                disable: true,
                controlsText: ["<span class='icon-left-circle'></span><span class='sr-only'>Left</span>", "<span class='icon-right-circle'></span><span class='sr-only'>Right</span>"],
                autoplayHoverPause: true,
                responsive:{
                    992:{

                        disable: false,

                    },
                    1300:{
                        items:5,
                        controls: true,

                    }
                },
                onInit: function (i) {
                    var c = $(i['container']);
                    c.css('display', 'flex');
                }
            });
        });
    }
    $('.open-search').on('click', function (e) {
        e.preventDefault();
        $('.search-container').toggleClass('show')
        $menu_overlay.removeClass('show');
        $('.menu-container').removeClass('show');
        $(document).find('.cart-menu').removeClass('show')
        $('.cart-icon').removeClass('cart-opened');
        $('body').removeClass('menu-show')
        if($shop_sidebar_wrapper.hasClass('show')) {
            $shop_sidebar_wrapper.removeClass('show');
            $('.filters-overlay').removeClass('show')
        }
    })
    $('.close-search').on('click', function (e) {
        e.preventDefault()
        $('.search-container').removeClass('show')
    })

    if($('.seasons-repeater').find('ul.products').length > 0){

        var sliders = document.querySelectorAll('.seasons-repeater ul.products');

        forEach(sliders, function (index, value) {
            var slider = tns({
                container: value,
                loop:false,
                mouseDrag:true,
                navPosition:'bottom',
                gutter:20,
                items:1.3,
                nav:false,
                preventScrollOnTouch:false,
                controls:false,
                disable: true,
                slideBy: 1,
                controlsText: ["</span> <span class='icon-arrow-right'></span><span class='sr-only'>Right</span>", "<span class='icon-arrow-left'><span class='sr-only'>Left</span>"],
                // autoplayHoverPause: true,
                responsive:{
                    992:{
                        items:4,
                        controls: true,
                        disable: false,
                        slideBy: 'page',
                    },
                    1300:{
                        items:5,
                        controls: true,
                        disable: false,
                        slideBy: 'page',
                    },
                },
                onInit: function (i) {
                    var c = $(i['container']);
                    c.css('display', 'flex');
                }
            });
        });
    }

    $(document).on('keypress', '.cart-collaterals .coupon #coupon_code_custom', function (e) {
        $( '.woocommerce-cart-form .coupon #coupon_code').val($( '.cart-collaterals .coupon #coupon_code_custom').val())
        if(e.which === 13){
            e.preventDefault();
            $(document).find('.woocommerce-cart-form').find('.coupon').find('button').trigger('click');
        }
    });

    $('.cart-collaterals .coupon button').on('click',function (e) {
        e.preventDefault();
        $( '.woocommerce-cart-form .coupon #coupon_code').val($( '.cart-collaterals .coupon #coupon_code_custom').val())
        $(document).find('.woocommerce-cart-form').find('.coupon').find('button').trigger('click');
    })
    $('[data-toggle="tooltip"]').tooltip()
    $(document).on('click', '.social-icons a', function() {console.log('aa')
        var left = (screen.width / 2) - (550 / 2);
        var top = (screen.height / 2) - (350 / 2);
        var NWin = window.open(jQuery(this).prop('href'), '', 'height=350,width=550,top=' + top + ', left=' + left);
        if (window.focus) {
            NWin.focus();
        }
        return false;
    });
    if (jQuery(window).width() <992) {
        jQuery(document).find('.main-menu-container').find('.menu-container').css('top', (jQuery('.header-bar').outerHeight()+jQuery('.main-menu-container').outerHeight() )+'px')
        jQuery(document).find('.top-bar').find('.cart-menu').css('top', (jQuery('.header-bar').outerHeight()+jQuery('.main-menu-container').outerHeight() )+'px')
        jQuery(document).find('.sidebar-filters').css('top', (jQuery('.header-bar').outerHeight()+jQuery('.main-menu-container').outerHeight() )+'px')
    }

    if($('body').hasClass('single-product') ) {
        if (jQuery(window).width() <768) {
            setTimeout(function () {
                var div_sum = $('.woocommerce').find('div.product').find('div.summary.entry-summary');console.log(div_sum.height());
                div_sum.height(div_sum.height())
            }, 100)
        }
        $(window).scroll(function () {
            if (jQuery(window).width() <768) {
                var elem = $('.woocommerce').find('div.product').find('.summary');
                var top_of_element = elem.offset().top;
                var min = 0;
                if($(document).find('div.product').find('.brand-container').length>0)min = $(document).find('div.product').find('.brand-container').outerHeight()
                var bottom_of_element = elem.offset().top + elem.outerHeight() - min - ($('.header-section').outerHeight() *2);
                var bottom_of_screen = $(window).scrollTop() + $(window).innerHeight();
                var top_of_screen = $(window).scrollTop();

                if ( (bottom_of_screen < top_of_element)) {//(bottom_of_screen > top_of_element) &&
                    $('form.cart').removeClass('fixed')
                } else {
                    $('form.cart').addClass('fixed')
                }
            }
        });
    }

    $('.product-filters').on('click', function (e) {
        e.preventDefault()
        $shop_sidebar_wrapper.toggleClass('show')
        $('.filters-overlay').toggleClass('show')
    })
    $('.filters-overlay').on('click', function (e) {
        e.preventDefault()
        $shop_sidebar_wrapper.removeClass('show')
        $(this).removeClass('show')
    })
    $(document).on('click', '.berocket_aapf_widget .berocket_label_widgets', function (e) {
        if($shop_sidebar_wrapper.hasClass('show')){
            $(document).find('.berocket_aapf_widget_show.hide_button').trigger('click')
            $('.filters-overlay').removeClass('show');
            $shop_sidebar_wrapper.removeClass('show');
        }
    });
    $(document).on('slidestop', '.berocket_slidered', function() {
        if($shop_sidebar_wrapper.hasClass('show')){
            $(document).find('.berocket_aapf_widget_show.hide_button').trigger('click')
            $('.filters-overlay').removeClass('show');
            $shop_sidebar_wrapper.removeClass('show');
        }
    });


    $('.custom-coupon-form #apply_coupon').on('click',function (e) {
        e.preventDefault();
        $(document).find('form.checkout_coupon #coupon_code').val($('form.woocommerce-checkout .custom-coupon-form #coupon_code_custom').val());
        $(document).find('form.checkout_coupon').trigger('submit')
    })

    $(document).on('keypress', '.custom-coupon-form #coupon_code_custom', function (e) {
        if(e.which === 13){
            e.preventDefault();
            $(document).find('form.checkout_coupon #coupon_code').val($('form.woocommerce-checkout .custom-coupon-form #coupon_code_custom').val());
            $(document).find('form.checkout_coupon').trigger('submit')
        }
    });
    $( document.body ).on( 'applied_coupon_in_checkout', function ($coupon_code) {
        if($(document).find('.woocommerce-error').find('li').length > 0){
            $("html, body").animate({ scrollTop: $($(document).find('.woocommerce-error')).offset().top - ($('.main-menu-container').height() *2)}, "slow");
        }
    } );

    var $track_results=$('.track-results');
    $('#track-order-form').on('submit', function (e) {
        e.preventDefault();

        $track_results.hide().html('<span class="spinner-img mt-5"></span>').show();
        var $btn = $(this).find('.btn');
        $btn.prop('disabled', true).find('span').remove();
        $btn.append('<span class="icon-spinner animate-spin ms-2"></span>')
        var $val = $('input[name="order_id"]').val();
        let emailOrPhone = $(this).find('[name="email_or_phone"]').val();

        if(!$val.trim().length || !emailOrPhone.trim().length){
            $track_results.hide().html();
            swal({icon: 'error',text: 'Ο κωδικός της παραγγελίας και το πεδίο email/τηλέφωνο δεν πρέπει να είναι κενά.'});
            $btn.prop('disabled', false).find('span').remove();
        }else{
            var data = {action: 'get_order_html', code:$val, email_or_phone: emailOrPhone};
            jQuery.post(ajax_object.ajax_url, data, function (response) {
                if(response.error === 0) {
                    $btn.prop('disabled', false).find('span').toggleClass('icon-spinner animate-spin icon-check');
                    $track_results.hide().html(response.html);
                    $track_results.fadeIn()
                }else{
                    $track_results.hide().html();
                    swal({icon: 'error',text: 'Ο κωδικός της παραγγελίας ή το email/τηλέφωνο δεν είναι σωστά.'});
                    $btn.prop('disabled', false).find('span').remove();
                }
            });
        }
    });

    //new product
    if($('#new').length > 0) {
        var slider = tns({
            container: '#new ul.products',
            loop: false,
            autoplay:false,
            speed:800,
            mouseDrag: true,
            navPosition: 'bottom',
            gutter: 20,
            items: 1.5,
            nav: false,
            preventScrollOnTouch: false,
            controls: true,
            controlsText: ["</span> <span class='icon-arrow-right'></span><span class='sr-only'>Right</span>", "<span class='icon-arrow-left'><span class='sr-only'>Left</span>"],
            autoplayHoverPause: true,
            disable: true,
            responsive: {
                991: {
                    disable: false,
                },
                1200:{
                    items:5,
                    controls: true,
                    gutter: 30,
                }

            },
            onInit: function (i) {
                var c = $(i['container']);
                c.css('display', 'flex');
            }
        });
    }


});